import React from "react";
import PlayerConstants from "../../../shared/constants/player";
const { LIVE } = PlayerConstants.PLAYER_TYPE;

const ChannelInfo = ({ channelNumber, type, image, onError }) => {
  return (
    <div className="channel-info">
      {channelNumber ? <div className="live-channel-number">{channelNumber}</div> : null}
      {type === LIVE ? <img src={image + "?w=100"} alt="Channel Logo" onError={onError} /> : null}
    </div>
  );
};

export default ChannelInfo;
